
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M5.177 16.43a4.677 4.677 0 100-9.354 4.677 4.677 0 000 9.355z","fill":"#D0E8F8"}}),_c('path',{attrs:{"d":"M11.845 18.649a4.28 4.28 0 100-8.561 4.28 4.28 0 000 8.56z","fill":"#fff"}}),_c('path',{attrs:{"d":"M17.212 13.399a3.629 3.629 0 100-7.257 3.629 3.629 0 000 7.257z","fill":"#fff"}}),_c('path',{attrs:{"d":"M10.9 11.995A3.498 3.498 0 1010.9 5a3.498 3.498 0 000 6.995z","fill":"#D0E8F8"}}),_c('path',{attrs:{"d":"M21.444 15.362a3.056 3.056 0 100-6.113 3.056 3.056 0 000 6.113z","fill":"#fff"}}),_c('path',{attrs:{"d":"M17.712 16.114a3.056 3.056 0 100-6.113 3.056 3.056 0 000 6.113z","fill":"#D0E8F8"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    